(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreController', SettoreController);

    SettoreController.$inject = ['Settore'];

    function SettoreController(Settore) {

        var vm = this;

        vm.settores = [];

        loadAll();

        function loadAll() {
            Settore.query(function(result) {
                vm.settores = result;
                vm.searchQuery = null;
            });
        }
    }
})();
